/**
 * Study export operations — .skjv format encoding.
 */

import type { Study, StudyGroup } from '@skjv/common';
import { encodeSkjv } from '@/services/skjv-codec';

/** Export a single study as .skjv format (includes its study group) */
export function exportStudyToJson(
  studies: Study[],
  studyGroups: StudyGroup[],
  id: string,
): string | null {
  const study = studies.find((s) => s.id === id);
  if (!study) return null;

  const group = studyGroups.find((g) => g.id === study.studyGroupId);
  const exportData = {
    ...study,
    studyGroup: group,
  };
  return encodeSkjv(exportData);
}

/** Export all studies as hex-encoded .skjv format */
export function exportAllToJson(
  studies: Study[],
  studyGroups: StudyGroup[],
  now: string,
): string {
  return encodeSkjv({
    studies,
    studyGroups,
    exportedAt: now,
  });
}
